export const GET_LICENCE_CAP_SUMMARY_REQUEST = 'GET_LICENCE_CAP_SUMMARY_REQUEST';
export const GET_LICENCE_CAP_SUMMARY_SUCCESS = 'GET_LICENCE_CAP_SUMMARY_SUCCESS';
export const GET_LICENCE_CAP_SUMMARY_FAILURE = 'GET_LICENCE_CAP_SUMMARY_FAILURE';

export const getLicenceCapSummary = productId =>
    ({ type: GET_LICENCE_CAP_SUMMARY_REQUEST, productId });

export const getLicenceCapSummarySuccess = ({ data }) =>
    ({ type: GET_LICENCE_CAP_SUMMARY_SUCCESS, data });

export const getLicenceCapSummaryFailure = () =>
    ({ type: GET_LICENCE_CAP_SUMMARY_FAILURE });

export const GET_COUNTRIES_REQUEST = 'GET_COUNTRIES_REQUEST';
export const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS';
export const GET_COUNTRIES_FAILURE = 'GET_COUNTRIES_FAILURE';

export const getCourseCountries = selectedProductId =>
    ({ type: GET_COUNTRIES_REQUEST, selectedProductId });

export const getCourseCountriesSuccess = data =>
    ({ type: GET_COUNTRIES_SUCCESS, data });

export const getCourseCountriesFailure = () =>
    ({ type: GET_COUNTRIES_FAILURE });

export const GET_UPF_COUNTRIES_REQUEST = 'GET_UPF_COUNTRIES_REQUEST';
export const GET_UPF_COUNTRIES_SUCCESS = 'GET_UPF_COUNTRIES_SUCCESS';
export const GET_UPF_COUNTRIES_FAILURE = 'GET_UPF_COUNTRIES_FAILURE';

export const getUpfCourseCountries = selectedProductId =>
    ({ type: GET_UPF_COUNTRIES_REQUEST, selectedProductId });

export const getUpfCourseCountriesSuccess = data =>
    ({ type: GET_UPF_COUNTRIES_SUCCESS, data });

export const getUpfCourseCountriesFailure = () =>
    ({ type: GET_UPF_COUNTRIES_FAILURE });

export const GET_YEAR_GROUPS_REQUEST = 'GET_YEAR_GROUPS_REQUEST';
export const GET_YEAR_GROUPS_SUCCESS = 'GET_YEAR_GROUPS_SUCCESS';
export const GET_YEAR_GROUPS_FAILURE = 'GET_YEAR_GROUPS_FAILURE';

export const getYearGroups = () =>
    ({ type: GET_YEAR_GROUPS_REQUEST });

export const getYearGroupsSuccess = ({ data }) =>
    ({ type: GET_YEAR_GROUPS_SUCCESS, data });

export const getYearGroupsFailure = () =>
    ({ type: GET_YEAR_GROUPS_FAILURE });



// WEBPACK FOOTER //
// ./app/containers/school-roll/actions.js